export const formatPhoneNumberToMask = (phoneNumber) => {
    const cleaned = phoneNumber?.replace(/\D/g, '');
    const match = cleaned?.match(/^(\d{3})(\d{3})(\d{2})(\d{2})$/);

    if (match) {
        return '+38 (' + match[1] + ') ' + match[2] + ' ' + match[3] + ' ' + match[4];
    }

    // Never return null: react-input-mask (a class component) calls .split on
    // its value in componentDidUpdate and crashes the whole profile page when
    // the user has no/blank phone. An empty string keeps the mask happy.
    return '';
}